const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
const {Input} = require('ui-library');
const _ = require('lodash');
const Mixins = require('../../lib/mixins');

const BillingInfo = createClass({

  mixins: [
    Mixins.linkMixin
  ],

  propTypes: {
    currentBillingInfo: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  },

  onChange(property, evt) {
    var {value} = evt.target;
    var {onChange} = this.props;

    onChange(property, value);
  },

  render() {
    var {currentBillingInfo, nameClassName, formStatusClass, onChange} = this.props;
    var currentBillingInfo = _.clone(currentBillingInfo);

    if(currentBillingInfo === null) return(<div></div>);

    return(
      <div className='md-12'>
        <div className='padding-bottom-1x sm-nopadding clearfix'>
          <div className='sm-12 sm-nopadding sm-margin-bottom-1x md-6 column '>
            <label className='vf-simple-form-label'>Nombre o razón social (obligatorio)</label>
            <Input className={formStatusClass} value={currentBillingInfo.name} onChange={this.onChange.bind(null, 'name')} />
          </div>

          <div className='sm-12 sm-nopadding sm-margin-bottom-1x md-6 column'>
            <label className='vf-simple-form-label'>RFC o VAT</label>
            <Input value={currentBillingInfo.vat} onChange={this.onChange.bind(null, 'vat')} />
          </div>
        </div>

        <div className='padding-bottom-1x sm-nopadding clearfix'>
          <div className='sm-12 sm-nopadding sm-margin-bottom-1x md-6 column '>
            <label className='vf-simple-form-label'>País</label>
            <Input value={currentBillingInfo.country} onChange={this.onChange.bind(null, 'country')} />
          </div>

          <div className='sm-12 sm-nopadding sm-margin-bottom-1x md-6 column'>
            <label className='vf-simple-form-label'>Estado</label>
            <Input value={currentBillingInfo.state} onChange={this.onChange.bind(null, 'state')} />
          </div>
        </div>

        <div className='padding-bottom-1x sm-nopadding clearfix'>
          <div className='sm-12 sm-nopadding sm-margin-bottom-1x md-6 column '>
            <label className='vf-simple-form-label'>Ciudad</label>
            <Input value={currentBillingInfo.city} onChange={this.onChange.bind(null, 'city')} />
          </div>

          <div className='sm-12 sm-nopadding sm-margin-bottom-1x md-6 column'>
            <label className='vf-simple-form-label'>Código postal</label>
            <Input value={currentBillingInfo.zipCode} onChange={this.onChange.bind(null, 'zipCode')} />
          </div>
        </div>

        <div className='padding-bottom-1x clearfix'>
          <div className='md-12 column '>
            <label className='vf-simple-form-label'>Dirección</label>
            <Input value={currentBillingInfo.address} onChange={this.onChange.bind(null, 'address')} />
          </div>
        </div>
      </div>
    );
  }
})

module.exports = BillingInfo;
